(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as se, jsxs as We, Fragment as cn } from "react/jsx-runtime";
import { useMemo as ke, useCallback as pn, useEffect as yn } from "react";
import { useRouter as Ht } from "next/router";
import { c as Ge } from "../../chunks/clsx.OuTLNxxd.js";
import { c as Ie, g as hn } from "../../chunks/_commonjsHelpers.asqBjCHr.js";
import { NeuNavSecondary as Qr, NeuCard as Jr, NeuTab as Zr } from "@hcahealthcaredpx/neutron-react";
import { withDatasourceCheck as dn, Placeholder as Yr } from "@sitecore-jss/sitecore-jss-nextjs";
import { u as vn } from "../../chunks/utils.Y3kKu2Hm.js";
import { useMutationState as mn } from "@tanstack/react-query";
import { S as gn } from "../../chunks/scroll-into-view-alert.gURnqzmn.js";
import { i as Sn } from "../../chunks/isString.CBBtl6e7.js";
import { u as wn } from "../../chunks/uniqueId.BPnVtyx5.js";
var de = {}, xe = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
var bn = xe.exports, Xr;
function On() {
  return Xr || (Xr = 1, function(i, l) {
    (function(v) {
      var h = l && !l.nodeType && l, m = i && !i.nodeType && i, R = typeof Ie == "object" && Ie;
      (R.global === R || R.window === R || R.self === R) && (v = R);
      var _, g = 2147483647, E = 36, w = 1, b = 26, O = 38, c = 700, d = 72, a = 128, u = "-", o = /^xn--/, T = /[^\x20-\x7E]/, x = /[\x2E\u3002\uFF0E\uFF61]/g, F = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, z = E - w, r = Math.floor, y = String.fromCharCode, e;
      function f(P) {
        throw new RangeError(F[P]);
      }
      function S(P, I) {
        for (var L = P.length, A = []; L--; )
          A[L] = I(P[L]);
        return A;
      }
      function q(P, I) {
        var L = P.split("@"), A = "";
        L.length > 1 && (A = L[0] + "@", P = L[1]), P = P.replace(x, ".");
        var D = P.split("."), K = S(D, I).join(".");
        return A + K;
      }
      function C(P) {
        for (var I = [], L = 0, A = P.length, D, K; L < A; )
          D = P.charCodeAt(L++), D >= 55296 && D <= 56319 && L < A ? (K = P.charCodeAt(L++), (K & 64512) == 56320 ? I.push(((D & 1023) << 10) + (K & 1023) + 65536) : (I.push(D), L--)) : I.push(D);
        return I;
      }
      function p(P) {
        return S(P, function(I) {
          var L = "";
          return I > 65535 && (I -= 65536, L += y(I >>> 10 & 1023 | 55296), I = 56320 | I & 1023), L += y(I), L;
        }).join("");
      }
      function j(P) {
        return P - 48 < 10 ? P - 22 : P - 65 < 26 ? P - 65 : P - 97 < 26 ? P - 97 : E;
      }
      function N(P, I) {
        return P + 22 + 75 * (P < 26) - ((I != 0) << 5);
      }
      function V(P, I, L) {
        var A = 0;
        for (P = L ? r(P / c) : P >> 1, P += r(P / I); P > z * b >> 1; A += E)
          P = r(P / z);
        return r(A + (z + 1) * P / (P + O));
      }
      function $(P) {
        var I = [], L = P.length, A, D = 0, K = a, k = d, Q, te, H, M, U, W, J, Z, ne;
        for (Q = P.lastIndexOf(u), Q < 0 && (Q = 0), te = 0; te < Q; ++te)
          P.charCodeAt(te) >= 128 && f("not-basic"), I.push(P.charCodeAt(te));
        for (H = Q > 0 ? Q + 1 : 0; H < L; ) {
          for (M = D, U = 1, W = E; H >= L && f("invalid-input"), J = j(P.charCodeAt(H++)), (J >= E || J > r((g - D) / U)) && f("overflow"), D += J * U, Z = W <= k ? w : W >= k + b ? b : W - k, !(J < Z); W += E)
            ne = E - Z, U > r(g / ne) && f("overflow"), U *= ne;
          A = I.length + 1, k = V(D - M, A, M == 0), r(D / A) > g - K && f("overflow"), K += r(D / A), D %= A, I.splice(D++, 0, K);
        }
        return p(I);
      }
      function B(P) {
        var I, L, A, D, K, k, Q, te, H, M, U, W = [], J, Z, ne, ae;
        for (P = C(P), J = P.length, I = a, L = 0, K = d, k = 0; k < J; ++k)
          U = P[k], U < 128 && W.push(y(U));
        for (A = D = W.length, D && W.push(u); A < J; ) {
          for (Q = g, k = 0; k < J; ++k)
            U = P[k], U >= I && U < Q && (Q = U);
          for (Z = A + 1, Q - I > r((g - L) / Z) && f("overflow"), L += (Q - I) * Z, I = Q, k = 0; k < J; ++k)
            if (U = P[k], U < I && ++L > g && f("overflow"), U == I) {
              for (te = L, H = E; M = H <= K ? w : H >= K + b ? b : H - K, !(te < M); H += E)
                ae = te - M, ne = E - M, W.push(
                  y(N(M + ae % ne, 0))
                ), te = r(ae / ne);
              W.push(y(N(te, 0))), K = V(L, Z, A == D), L = 0, ++A;
            }
          ++L, ++I;
        }
        return W.join("");
      }
      function s(P) {
        return q(P, function(I) {
          return o.test(I) ? $(I.slice(4).toLowerCase()) : I;
        });
      }
      function X(P) {
        return q(P, function(I) {
          return T.test(I) ? "xn--" + B(I) : I;
        });
      }
      if (_ = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: C,
          encode: p
        },
        decode: $,
        encode: B,
        toASCII: X,
        toUnicode: s
      }, h && m)
        if (i.exports == h)
          m.exports = _;
        else
          for (e in _)
            _.hasOwnProperty(e) && (h[e] = _[e]);
      else
        v.punycode = _;
    })(bn);
  }(xe, xe.exports)), xe.exports;
}
var ze, et;
function Oe() {
  return et || (et = 1, ze = TypeError), ze;
}
const An = {}, En = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: An
}, Symbol.toStringTag, { value: "Module" })), xn = /* @__PURE__ */ hn(En);
var je, rt;
function Ce() {
  if (rt) return je;
  rt = 1;
  var i = typeof Map == "function" && Map.prototype, l = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, v = i && l && typeof l.get == "function" ? l.get : null, h = i && Map.prototype.forEach, m = typeof Set == "function" && Set.prototype, R = Object.getOwnPropertyDescriptor && m ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, _ = m && R && typeof R.get == "function" ? R.get : null, g = m && Set.prototype.forEach, E = typeof WeakMap == "function" && WeakMap.prototype, w = E ? WeakMap.prototype.has : null, b = typeof WeakSet == "function" && WeakSet.prototype, O = b ? WeakSet.prototype.has : null, c = typeof WeakRef == "function" && WeakRef.prototype, d = c ? WeakRef.prototype.deref : null, a = Boolean.prototype.valueOf, u = Object.prototype.toString, o = Function.prototype.toString, T = String.prototype.match, x = String.prototype.slice, F = String.prototype.replace, z = String.prototype.toUpperCase, r = String.prototype.toLowerCase, y = RegExp.prototype.test, e = Array.prototype.concat, f = Array.prototype.join, S = Array.prototype.slice, q = Math.floor, C = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, p = Object.getOwnPropertySymbols, j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, N = typeof Symbol == "function" && typeof Symbol.iterator == "object", V = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === N || !0) ? Symbol.toStringTag : null, $ = Object.prototype.propertyIsEnumerable, B = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
    return t.__proto__;
  } : null);
  function s(t, n) {
    if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || y.call(/e/, n))
      return n;
    var Y = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof t == "number") {
      var ee = t < 0 ? -q(-t) : q(t);
      if (ee !== t) {
        var re = String(ee), G = x.call(n, re.length + 1);
        return F.call(re, Y, "$&_") + "." + F.call(F.call(G, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return F.call(n, Y, "$&_");
  }
  var X = xn, P = X.custom, I = Z(P) ? P : null, L = {
    __proto__: null,
    double: '"',
    single: "'"
  }, A = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  je = function t(n, Y, ee, re) {
    var G = Y || {};
    if (oe(G, "quoteStyle") && !oe(L, G.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (oe(G, "maxStringLength") && (typeof G.maxStringLength == "number" ? G.maxStringLength < 0 && G.maxStringLength !== 1 / 0 : G.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var pe = oe(G, "customInspect") ? G.customInspect : !0;
    if (typeof pe != "boolean" && pe !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (oe(G, "indent") && G.indent !== null && G.indent !== "	" && !(parseInt(G.indent, 10) === G.indent && G.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (oe(G, "numericSeparator") && typeof G.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var he = G.numericSeparator;
    if (typeof n > "u")
      return "undefined";
    if (n === null)
      return "null";
    if (typeof n == "boolean")
      return n ? "true" : "false";
    if (typeof n == "string")
      return Lr(n, G);
    if (typeof n == "number") {
      if (n === 0)
        return 1 / 0 / n > 0 ? "0" : "-0";
      var fe = String(n);
      return he ? s(n, fe) : fe;
    }
    if (typeof n == "bigint") {
      var ye = String(n) + "n";
      return he ? s(n, ye) : ye;
    }
    var Me = typeof G.depth > "u" ? 5 : G.depth;
    if (typeof ee > "u" && (ee = 0), ee >= Me && Me > 0 && typeof n == "object")
      return Q(n) ? "[Array]" : "[Object]";
    var we = un(G, ee);
    if (typeof re > "u")
      re = [];
    else if (ce(re, n) >= 0)
      return "[Circular]";
    function le(be, qe, sn) {
      if (qe && (re = S.call(re), re.push(qe)), sn) {
        var Vr = {
          depth: G.depth
        };
        return oe(G, "quoteStyle") && (Vr.quoteStyle = G.quoteStyle), t(be, Vr, ee + 1, re);
      }
      return t(be, G, ee + 1, re);
    }
    if (typeof n == "function" && !H(n)) {
      var Wr = ve(n), kr = Pe(n, le);
      return "[Function" + (Wr ? ": " + Wr : " (anonymous)") + "]" + (kr.length > 0 ? " { " + f.call(kr, ", ") + " }" : "");
    }
    if (Z(n)) {
      var Gr = N ? F.call(String(n), /^(Symbol\(.*\))_[^)]*$/, "$1") : j.call(n);
      return typeof n == "object" && !N ? Ae(Gr) : Gr;
    }
    if (an(n)) {
      for (var Ee = "<" + r.call(String(n.nodeName)), De = n.attributes || [], Re = 0; Re < De.length; Re++)
        Ee += " " + De[Re].name + "=" + D(K(De[Re].value), "double", G);
      return Ee += ">", n.childNodes && n.childNodes.length && (Ee += "..."), Ee += "</" + r.call(String(n.nodeName)) + ">", Ee;
    }
    if (Q(n)) {
      if (n.length === 0)
        return "[]";
      var Ne = Pe(n, le);
      return we && !fn(Ne) ? "[" + Te(Ne, we) + "]" : "[ " + f.call(Ne, ", ") + " ]";
    }
    if (M(n)) {
      var $e = Pe(n, le);
      return !("cause" in Error.prototype) && "cause" in n && !$.call(n, "cause") ? "{ [" + String(n) + "] " + f.call(e.call("[cause]: " + le(n.cause), $e), ", ") + " }" : $e.length === 0 ? "[" + String(n) + "]" : "{ [" + String(n) + "] " + f.call($e, ", ") + " }";
    }
    if (typeof n == "object" && pe) {
      if (I && typeof n[I] == "function" && X)
        return X(n, { depth: Me - ee });
      if (pe !== "symbol" && typeof n.inspect == "function")
        return n.inspect();
    }
    if (ue(n)) {
      var zr = [];
      return h && h.call(n, function(be, qe) {
        zr.push(le(qe, n, !0) + " => " + le(be, n));
      }), Ur("Map", v.call(n), zr, we);
    }
    if (Se(n)) {
      var jr = [];
      return g && g.call(n, function(be) {
        jr.push(le(be, n));
      }), Ur("Set", _.call(n), jr, we);
    }
    if (me(n))
      return _e("WeakMap");
    if (nn(n))
      return _e("WeakSet");
    if (ge(n))
      return _e("WeakRef");
    if (W(n))
      return Ae(le(Number(n)));
    if (ne(n))
      return Ae(le(C.call(n)));
    if (J(n))
      return Ae(a.call(n));
    if (U(n))
      return Ae(le(String(n)));
    if (typeof window < "u" && n === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && n === globalThis || typeof Ie < "u" && n === Ie)
      return "{ [object globalThis] }";
    if (!te(n) && !H(n)) {
      var Be = Pe(n, le), Hr = B ? B(n) === Object.prototype : n instanceof Object || n.constructor === Object, Le = n instanceof Object ? "" : "null prototype", Kr = !Hr && V && Object(n) === n && V in n ? x.call(ie(n), 8, -1) : Le ? "Object" : "", ln = Hr || typeof n.constructor != "function" ? "" : n.constructor.name ? n.constructor.name + " " : "", Ue = ln + (Kr || Le ? "[" + f.call(e.call([], Kr || [], Le || []), ": ") + "] " : "");
      return Be.length === 0 ? Ue + "{}" : we ? Ue + "{" + Te(Be, we) + "}" : Ue + "{ " + f.call(Be, ", ") + " }";
    }
    return String(n);
  };
  function D(t, n, Y) {
    var ee = Y.quoteStyle || n, re = L[ee];
    return re + t + re;
  }
  function K(t) {
    return F.call(String(t), /"/g, "&quot;");
  }
  function k(t) {
    return !V || !(typeof t == "object" && (V in t || typeof t[V] < "u"));
  }
  function Q(t) {
    return ie(t) === "[object Array]" && k(t);
  }
  function te(t) {
    return ie(t) === "[object Date]" && k(t);
  }
  function H(t) {
    return ie(t) === "[object RegExp]" && k(t);
  }
  function M(t) {
    return ie(t) === "[object Error]" && k(t);
  }
  function U(t) {
    return ie(t) === "[object String]" && k(t);
  }
  function W(t) {
    return ie(t) === "[object Number]" && k(t);
  }
  function J(t) {
    return ie(t) === "[object Boolean]" && k(t);
  }
  function Z(t) {
    if (N)
      return t && typeof t == "object" && t instanceof Symbol;
    if (typeof t == "symbol")
      return !0;
    if (!t || typeof t != "object" || !j)
      return !1;
    try {
      return j.call(t), !0;
    } catch {
    }
    return !1;
  }
  function ne(t) {
    if (!t || typeof t != "object" || !C)
      return !1;
    try {
      return C.call(t), !0;
    } catch {
    }
    return !1;
  }
  var ae = Object.prototype.hasOwnProperty || function(t) {
    return t in this;
  };
  function oe(t, n) {
    return ae.call(t, n);
  }
  function ie(t) {
    return u.call(t);
  }
  function ve(t) {
    if (t.name)
      return t.name;
    var n = T.call(o.call(t), /^function\s*([\w$]+)/);
    return n ? n[1] : null;
  }
  function ce(t, n) {
    if (t.indexOf)
      return t.indexOf(n);
    for (var Y = 0, ee = t.length; Y < ee; Y++)
      if (t[Y] === n)
        return Y;
    return -1;
  }
  function ue(t) {
    if (!v || !t || typeof t != "object")
      return !1;
    try {
      v.call(t);
      try {
        _.call(t);
      } catch {
        return !0;
      }
      return t instanceof Map;
    } catch {
    }
    return !1;
  }
  function me(t) {
    if (!w || !t || typeof t != "object")
      return !1;
    try {
      w.call(t, w);
      try {
        O.call(t, O);
      } catch {
        return !0;
      }
      return t instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function ge(t) {
    if (!d || !t || typeof t != "object")
      return !1;
    try {
      return d.call(t), !0;
    } catch {
    }
    return !1;
  }
  function Se(t) {
    if (!_ || !t || typeof t != "object")
      return !1;
    try {
      _.call(t);
      try {
        v.call(t);
      } catch {
        return !0;
      }
      return t instanceof Set;
    } catch {
    }
    return !1;
  }
  function nn(t) {
    if (!O || !t || typeof t != "object")
      return !1;
    try {
      O.call(t, O);
      try {
        w.call(t, w);
      } catch {
        return !0;
      }
      return t instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function an(t) {
    return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
  }
  function Lr(t, n) {
    if (t.length > n.maxStringLength) {
      var Y = t.length - n.maxStringLength, ee = "... " + Y + " more character" + (Y > 1 ? "s" : "");
      return Lr(x.call(t, 0, n.maxStringLength), n) + ee;
    }
    var re = A[n.quoteStyle || "single"];
    re.lastIndex = 0;
    var G = F.call(F.call(t, re, "\\$1"), /[\x00-\x1f]/g, on);
    return D(G, "single", n);
  }
  function on(t) {
    var n = t.charCodeAt(0), Y = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[n];
    return Y ? "\\" + Y : "\\x" + (n < 16 ? "0" : "") + z.call(n.toString(16));
  }
  function Ae(t) {
    return "Object(" + t + ")";
  }
  function _e(t) {
    return t + " { ? }";
  }
  function Ur(t, n, Y, ee) {
    var re = ee ? Te(Y, ee) : f.call(Y, ", ");
    return t + " (" + n + ") {" + re + "}";
  }
  function fn(t) {
    for (var n = 0; n < t.length; n++)
      if (ce(t[n], `
`) >= 0)
        return !1;
    return !0;
  }
  function un(t, n) {
    var Y;
    if (t.indent === "	")
      Y = "	";
    else if (typeof t.indent == "number" && t.indent > 0)
      Y = f.call(Array(t.indent + 1), " ");
    else
      return null;
    return {
      base: Y,
      prev: f.call(Array(n + 1), Y)
    };
  }
  function Te(t, n) {
    if (t.length === 0)
      return "";
    var Y = `
` + n.prev + n.base;
    return Y + f.call(t, "," + Y) + `
` + n.prev;
  }
  function Pe(t, n) {
    var Y = Q(t), ee = [];
    if (Y) {
      ee.length = t.length;
      for (var re = 0; re < t.length; re++)
        ee[re] = oe(t, re) ? n(t[re], t) : "";
    }
    var G = typeof p == "function" ? p(t) : [], pe;
    if (N) {
      pe = {};
      for (var he = 0; he < G.length; he++)
        pe["$" + G[he]] = G[he];
    }
    for (var fe in t)
      oe(t, fe) && (Y && String(Number(fe)) === fe && fe < t.length || N && pe["$" + fe] instanceof Symbol || (y.call(/[^\w$]/, fe) ? ee.push(n(fe, t) + ": " + n(t[fe], t)) : ee.push(fe + ": " + n(t[fe], t))));
    if (typeof p == "function")
      for (var ye = 0; ye < G.length; ye++)
        $.call(t, G[ye]) && ee.push("[" + n(G[ye]) + "]: " + n(t[G[ye]], t));
    return ee;
  }
  return je;
}
var He, tt;
function Pn() {
  if (tt) return He;
  tt = 1;
  var i = /* @__PURE__ */ Ce(), l = /* @__PURE__ */ Oe(), v = function(g, E, w) {
    for (var b = g, O; (O = b.next) != null; b = O)
      if (O.key === E)
        return b.next = O.next, w || (O.next = /** @type {NonNullable<typeof list.next>} */
        g.next, g.next = O), O;
  }, h = function(g, E) {
    if (g) {
      var w = v(g, E);
      return w && w.value;
    }
  }, m = function(g, E, w) {
    var b = v(g, E);
    b ? b.value = w : g.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: E,
      next: g.next,
      value: w
    };
  }, R = function(g, E) {
    return g ? !!v(g, E) : !1;
  }, _ = function(g, E) {
    if (g)
      return v(g, E, !0);
  };
  return He = function() {
    var E, w = {
      assert: function(b) {
        if (!w.has(b))
          throw new l("Side channel does not contain " + i(b));
      },
      delete: function(b) {
        var O = E && E.next, c = _(E, b);
        return c && O && O === c && (E = void 0), !!c;
      },
      get: function(b) {
        return h(E, b);
      },
      has: function(b) {
        return R(E, b);
      },
      set: function(b, O) {
        E || (E = {
          next: void 0
        }), m(
          /** @type {NonNullable<typeof $o>} */
          E,
          b,
          O
        );
      }
    };
    return w;
  }, He;
}
var Ke, nt;
function Kt() {
  return nt || (nt = 1, Ke = Object), Ke;
}
var Ve, at;
function Rn() {
  return at || (at = 1, Ve = Error), Ve;
}
var Qe, ot;
function qn() {
  return ot || (ot = 1, Qe = EvalError), Qe;
}
var Je, it;
function In() {
  return it || (it = 1, Je = RangeError), Je;
}
var Ze, ft;
function Cn() {
  return ft || (ft = 1, Ze = ReferenceError), Ze;
}
var Ye, ut;
function Fn() {
  return ut || (ut = 1, Ye = SyntaxError), Ye;
}
var Xe, lt;
function _n() {
  return lt || (lt = 1, Xe = URIError), Xe;
}
var er, st;
function Tn() {
  return st || (st = 1, er = Math.abs), er;
}
var rr, ct;
function Mn() {
  return ct || (ct = 1, rr = Math.floor), rr;
}
var tr, pt;
function Dn() {
  return pt || (pt = 1, tr = Math.max), tr;
}
var nr, yt;
function Nn() {
  return yt || (yt = 1, nr = Math.min), nr;
}
var ar, ht;
function $n() {
  return ht || (ht = 1, ar = Math.pow), ar;
}
var or, dt;
function Bn() {
  return dt || (dt = 1, or = Math.round), or;
}
var ir, vt;
function Ln() {
  return vt || (vt = 1, ir = Number.isNaN || function(l) {
    return l !== l;
  }), ir;
}
var fr, mt;
function Un() {
  if (mt) return fr;
  mt = 1;
  var i = /* @__PURE__ */ Ln();
  return fr = function(v) {
    return i(v) || v === 0 ? v : v < 0 ? -1 : 1;
  }, fr;
}
var ur, gt;
function Wn() {
  return gt || (gt = 1, ur = Object.getOwnPropertyDescriptor), ur;
}
var lr, St;
function Vt() {
  if (St) return lr;
  St = 1;
  var i = /* @__PURE__ */ Wn();
  if (i)
    try {
      i([], "length");
    } catch {
      i = null;
    }
  return lr = i, lr;
}
var sr, wt;
function kn() {
  if (wt) return sr;
  wt = 1;
  var i = Object.defineProperty || !1;
  if (i)
    try {
      i({}, "a", { value: 1 });
    } catch {
      i = !1;
    }
  return sr = i, sr;
}
var cr, bt;
function Gn() {
  return bt || (bt = 1, cr = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var l = {}, v = Symbol("test"), h = Object(v);
    if (typeof v == "string" || Object.prototype.toString.call(v) !== "[object Symbol]" || Object.prototype.toString.call(h) !== "[object Symbol]")
      return !1;
    var m = 42;
    l[v] = m;
    for (var R in l)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(l).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(l).length !== 0)
      return !1;
    var _ = Object.getOwnPropertySymbols(l);
    if (_.length !== 1 || _[0] !== v || !Object.prototype.propertyIsEnumerable.call(l, v))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var g = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(l, v)
      );
      if (g.value !== m || g.enumerable !== !0)
        return !1;
    }
    return !0;
  }), cr;
}
var pr, Ot;
function zn() {
  if (Ot) return pr;
  Ot = 1;
  var i = typeof Symbol < "u" && Symbol, l = Gn();
  return pr = function() {
    return typeof i != "function" || typeof Symbol != "function" || typeof i("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : l();
  }, pr;
}
var yr, At;
function Qt() {
  return At || (At = 1, yr = typeof Reflect < "u" && Reflect.getPrototypeOf || null), yr;
}
var hr, Et;
function Jt() {
  if (Et) return hr;
  Et = 1;
  var i = /* @__PURE__ */ Kt();
  return hr = i.getPrototypeOf || null, hr;
}
var dr, xt;
function jn() {
  if (xt) return dr;
  xt = 1;
  var i = "Function.prototype.bind called on incompatible ", l = Object.prototype.toString, v = Math.max, h = "[object Function]", m = function(E, w) {
    for (var b = [], O = 0; O < E.length; O += 1)
      b[O] = E[O];
    for (var c = 0; c < w.length; c += 1)
      b[c + E.length] = w[c];
    return b;
  }, R = function(E, w) {
    for (var b = [], O = w, c = 0; O < E.length; O += 1, c += 1)
      b[c] = E[O];
    return b;
  }, _ = function(g, E) {
    for (var w = "", b = 0; b < g.length; b += 1)
      w += g[b], b + 1 < g.length && (w += E);
    return w;
  };
  return dr = function(E) {
    var w = this;
    if (typeof w != "function" || l.apply(w) !== h)
      throw new TypeError(i + w);
    for (var b = R(arguments, 1), O, c = function() {
      if (this instanceof O) {
        var T = w.apply(
          this,
          m(b, arguments)
        );
        return Object(T) === T ? T : this;
      }
      return w.apply(
        E,
        m(b, arguments)
      );
    }, d = v(0, w.length - b.length), a = [], u = 0; u < d; u++)
      a[u] = "$" + u;
    if (O = Function("binder", "return function (" + _(a, ",") + "){ return binder.apply(this,arguments); }")(c), w.prototype) {
      var o = function() {
      };
      o.prototype = w.prototype, O.prototype = new o(), o.prototype = null;
    }
    return O;
  }, dr;
}
var vr, Pt;
function Fe() {
  if (Pt) return vr;
  Pt = 1;
  var i = jn();
  return vr = Function.prototype.bind || i, vr;
}
var mr, Rt;
function Nr() {
  return Rt || (Rt = 1, mr = Function.prototype.call), mr;
}
var gr, qt;
function Zt() {
  return qt || (qt = 1, gr = Function.prototype.apply), gr;
}
var Sr, It;
function Hn() {
  return It || (It = 1, Sr = typeof Reflect < "u" && Reflect && Reflect.apply), Sr;
}
var wr, Ct;
function Kn() {
  if (Ct) return wr;
  Ct = 1;
  var i = Fe(), l = Zt(), v = Nr(), h = Hn();
  return wr = h || i.call(v, l), wr;
}
var br, Ft;
function Yt() {
  if (Ft) return br;
  Ft = 1;
  var i = Fe(), l = /* @__PURE__ */ Oe(), v = Nr(), h = Kn();
  return br = function(R) {
    if (R.length < 1 || typeof R[0] != "function")
      throw new l("a function is required");
    return h(i, v, R);
  }, br;
}
var Or, _t;
function Vn() {
  if (_t) return Or;
  _t = 1;
  var i = Yt(), l = /* @__PURE__ */ Vt(), v;
  try {
    v = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (_) {
    if (!_ || typeof _ != "object" || !("code" in _) || _.code !== "ERR_PROTO_ACCESS")
      throw _;
  }
  var h = !!v && l && l(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), m = Object, R = m.getPrototypeOf;
  return Or = h && typeof h.get == "function" ? i([h.get]) : typeof R == "function" ? (
    /** @type {import('./get')} */
    function(g) {
      return R(g == null ? g : m(g));
    }
  ) : !1, Or;
}
var Ar, Tt;
function Qn() {
  if (Tt) return Ar;
  Tt = 1;
  var i = Qt(), l = Jt(), v = /* @__PURE__ */ Vn();
  return Ar = i ? function(m) {
    return i(m);
  } : l ? function(m) {
    if (!m || typeof m != "object" && typeof m != "function")
      throw new TypeError("getProto: not an object");
    return l(m);
  } : v ? function(m) {
    return v(m);
  } : null, Ar;
}
var Er, Mt;
function Jn() {
  if (Mt) return Er;
  Mt = 1;
  var i = Function.prototype.call, l = Object.prototype.hasOwnProperty, v = Fe();
  return Er = v.call(i, l), Er;
}
var xr, Dt;
function $r() {
  if (Dt) return xr;
  Dt = 1;
  var i, l = /* @__PURE__ */ Kt(), v = /* @__PURE__ */ Rn(), h = /* @__PURE__ */ qn(), m = /* @__PURE__ */ In(), R = /* @__PURE__ */ Cn(), _ = /* @__PURE__ */ Fn(), g = /* @__PURE__ */ Oe(), E = /* @__PURE__ */ _n(), w = /* @__PURE__ */ Tn(), b = /* @__PURE__ */ Mn(), O = /* @__PURE__ */ Dn(), c = /* @__PURE__ */ Nn(), d = /* @__PURE__ */ $n(), a = /* @__PURE__ */ Bn(), u = /* @__PURE__ */ Un(), o = Function, T = function(H) {
    try {
      return o('"use strict"; return (' + H + ").constructor;")();
    } catch {
    }
  }, x = /* @__PURE__ */ Vt(), F = /* @__PURE__ */ kn(), z = function() {
    throw new g();
  }, r = x ? function() {
    try {
      return arguments.callee, z;
    } catch {
      try {
        return x(arguments, "callee").get;
      } catch {
        return z;
      }
    }
  }() : z, y = zn()(), e = Qn(), f = Jt(), S = Qt(), q = Zt(), C = Nr(), p = {}, j = typeof Uint8Array > "u" || !e ? i : e(Uint8Array), N = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? i : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? i : ArrayBuffer,
    "%ArrayIteratorPrototype%": y && e ? e([][Symbol.iterator]()) : i,
    "%AsyncFromSyncIteratorPrototype%": i,
    "%AsyncFunction%": p,
    "%AsyncGenerator%": p,
    "%AsyncGeneratorFunction%": p,
    "%AsyncIteratorPrototype%": p,
    "%Atomics%": typeof Atomics > "u" ? i : Atomics,
    "%BigInt%": typeof BigInt > "u" ? i : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? i : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? i : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? i : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": v,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": h,
    "%Float16Array%": typeof Float16Array > "u" ? i : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? i : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? i : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? i : FinalizationRegistry,
    "%Function%": o,
    "%GeneratorFunction%": p,
    "%Int8Array%": typeof Int8Array > "u" ? i : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? i : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? i : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": y && e ? e(e([][Symbol.iterator]())) : i,
    "%JSON%": typeof JSON == "object" ? JSON : i,
    "%Map%": typeof Map > "u" ? i : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !y || !e ? i : e((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": l,
    "%Object.getOwnPropertyDescriptor%": x,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? i : Promise,
    "%Proxy%": typeof Proxy > "u" ? i : Proxy,
    "%RangeError%": m,
    "%ReferenceError%": R,
    "%Reflect%": typeof Reflect > "u" ? i : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? i : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !y || !e ? i : e((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? i : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": y && e ? e(""[Symbol.iterator]()) : i,
    "%Symbol%": y ? Symbol : i,
    "%SyntaxError%": _,
    "%ThrowTypeError%": r,
    "%TypedArray%": j,
    "%TypeError%": g,
    "%Uint8Array%": typeof Uint8Array > "u" ? i : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? i : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? i : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? i : Uint32Array,
    "%URIError%": E,
    "%WeakMap%": typeof WeakMap > "u" ? i : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? i : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? i : WeakSet,
    "%Function.prototype.call%": C,
    "%Function.prototype.apply%": q,
    "%Object.defineProperty%": F,
    "%Object.getPrototypeOf%": f,
    "%Math.abs%": w,
    "%Math.floor%": b,
    "%Math.max%": O,
    "%Math.min%": c,
    "%Math.pow%": d,
    "%Math.round%": a,
    "%Math.sign%": u,
    "%Reflect.getPrototypeOf%": S
  };
  if (e)
    try {
      null.error;
    } catch (H) {
      var V = e(e(H));
      N["%Error.prototype%"] = V;
    }
  var $ = function H(M) {
    var U;
    if (M === "%AsyncFunction%")
      U = T("async function () {}");
    else if (M === "%GeneratorFunction%")
      U = T("function* () {}");
    else if (M === "%AsyncGeneratorFunction%")
      U = T("async function* () {}");
    else if (M === "%AsyncGenerator%") {
      var W = H("%AsyncGeneratorFunction%");
      W && (U = W.prototype);
    } else if (M === "%AsyncIteratorPrototype%") {
      var J = H("%AsyncGenerator%");
      J && e && (U = e(J.prototype));
    }
    return N[M] = U, U;
  }, B = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, s = Fe(), X = /* @__PURE__ */ Jn(), P = s.call(C, Array.prototype.concat), I = s.call(q, Array.prototype.splice), L = s.call(C, String.prototype.replace), A = s.call(C, String.prototype.slice), D = s.call(C, RegExp.prototype.exec), K = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, k = /\\(\\)?/g, Q = function(M) {
    var U = A(M, 0, 1), W = A(M, -1);
    if (U === "%" && W !== "%")
      throw new _("invalid intrinsic syntax, expected closing `%`");
    if (W === "%" && U !== "%")
      throw new _("invalid intrinsic syntax, expected opening `%`");
    var J = [];
    return L(M, K, function(Z, ne, ae, oe) {
      J[J.length] = ae ? L(oe, k, "$1") : ne || Z;
    }), J;
  }, te = function(M, U) {
    var W = M, J;
    if (X(B, W) && (J = B[W], W = "%" + J[0] + "%"), X(N, W)) {
      var Z = N[W];
      if (Z === p && (Z = $(W)), typeof Z > "u" && !U)
        throw new g("intrinsic " + M + " exists, but is not available. Please file an issue!");
      return {
        alias: J,
        name: W,
        value: Z
      };
    }
    throw new _("intrinsic " + M + " does not exist!");
  };
  return xr = function(M, U) {
    if (typeof M != "string" || M.length === 0)
      throw new g("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof U != "boolean")
      throw new g('"allowMissing" argument must be a boolean');
    if (D(/^%?[^%]*%?$/, M) === null)
      throw new _("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var W = Q(M), J = W.length > 0 ? W[0] : "", Z = te("%" + J + "%", U), ne = Z.name, ae = Z.value, oe = !1, ie = Z.alias;
    ie && (J = ie[0], I(W, P([0, 1], ie)));
    for (var ve = 1, ce = !0; ve < W.length; ve += 1) {
      var ue = W[ve], me = A(ue, 0, 1), ge = A(ue, -1);
      if ((me === '"' || me === "'" || me === "`" || ge === '"' || ge === "'" || ge === "`") && me !== ge)
        throw new _("property names with quotes must have matching quotes");
      if ((ue === "constructor" || !ce) && (oe = !0), J += "." + ue, ne = "%" + J + "%", X(N, ne))
        ae = N[ne];
      else if (ae != null) {
        if (!(ue in ae)) {
          if (!U)
            throw new g("base intrinsic for " + M + " exists, but the property is not available.");
          return;
        }
        if (x && ve + 1 >= W.length) {
          var Se = x(ae, ue);
          ce = !!Se, ce && "get" in Se && !("originalValue" in Se.get) ? ae = Se.get : ae = ae[ue];
        } else
          ce = X(ae, ue), ae = ae[ue];
        ce && !oe && (N[ne] = ae);
      }
    }
    return ae;
  }, xr;
}
var Pr, Nt;
function Xt() {
  if (Nt) return Pr;
  Nt = 1;
  var i = /* @__PURE__ */ $r(), l = Yt(), v = l([i("%String.prototype.indexOf%")]);
  return Pr = function(m, R) {
    var _ = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      i(m, !!R)
    );
    return typeof _ == "function" && v(m, ".prototype.") > -1 ? l(
      /** @type {const} */
      [_]
    ) : _;
  }, Pr;
}
var Rr, $t;
function en() {
  if ($t) return Rr;
  $t = 1;
  var i = /* @__PURE__ */ $r(), l = /* @__PURE__ */ Xt(), v = /* @__PURE__ */ Ce(), h = /* @__PURE__ */ Oe(), m = i("%Map%", !0), R = l("Map.prototype.get", !0), _ = l("Map.prototype.set", !0), g = l("Map.prototype.has", !0), E = l("Map.prototype.delete", !0), w = l("Map.prototype.size", !0);
  return Rr = !!m && /** @type {Exclude<import('.'), false>} */
  function() {
    var O, c = {
      assert: function(d) {
        if (!c.has(d))
          throw new h("Side channel does not contain " + v(d));
      },
      delete: function(d) {
        if (O) {
          var a = E(O, d);
          return w(O) === 0 && (O = void 0), a;
        }
        return !1;
      },
      get: function(d) {
        if (O)
          return R(O, d);
      },
      has: function(d) {
        return O ? g(O, d) : !1;
      },
      set: function(d, a) {
        O || (O = new m()), _(O, d, a);
      }
    };
    return c;
  }, Rr;
}
var qr, Bt;
function Zn() {
  if (Bt) return qr;
  Bt = 1;
  var i = /* @__PURE__ */ $r(), l = /* @__PURE__ */ Xt(), v = /* @__PURE__ */ Ce(), h = en(), m = /* @__PURE__ */ Oe(), R = i("%WeakMap%", !0), _ = l("WeakMap.prototype.get", !0), g = l("WeakMap.prototype.set", !0), E = l("WeakMap.prototype.has", !0), w = l("WeakMap.prototype.delete", !0);
  return qr = R ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var O, c, d = {
        assert: function(a) {
          if (!d.has(a))
            throw new m("Side channel does not contain " + v(a));
        },
        delete: function(a) {
          if (R && a && (typeof a == "object" || typeof a == "function")) {
            if (O)
              return w(O, a);
          } else if (h && c)
            return c.delete(a);
          return !1;
        },
        get: function(a) {
          return R && a && (typeof a == "object" || typeof a == "function") && O ? _(O, a) : c && c.get(a);
        },
        has: function(a) {
          return R && a && (typeof a == "object" || typeof a == "function") && O ? E(O, a) : !!c && c.has(a);
        },
        set: function(a, u) {
          R && a && (typeof a == "object" || typeof a == "function") ? (O || (O = new R()), g(O, a, u)) : h && (c || (c = h()), c.set(a, u));
        }
      };
      return d;
    }
  ) : h, qr;
}
var Ir, Lt;
function rn() {
  if (Lt) return Ir;
  Lt = 1;
  var i = /* @__PURE__ */ Oe(), l = /* @__PURE__ */ Ce(), v = Pn(), h = en(), m = Zn(), R = m || h || v;
  return Ir = function() {
    var g, E = {
      assert: function(w) {
        if (!E.has(w))
          throw new i("Side channel does not contain " + l(w));
      },
      delete: function(w) {
        return !!g && g.delete(w);
      },
      get: function(w) {
        return g && g.get(w);
      },
      has: function(w) {
        return !!g && g.has(w);
      },
      set: function(w, b) {
        g || (g = R()), g.set(w, b);
      }
    };
    return E;
  }, Ir;
}
var Cr, Ut;
function Br() {
  if (Ut) return Cr;
  Ut = 1;
  var i = String.prototype.replace, l = /%20/g, v = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Cr = {
    default: v.RFC3986,
    formatters: {
      RFC1738: function(h) {
        return i.call(h, l, "+");
      },
      RFC3986: function(h) {
        return String(h);
      }
    },
    RFC1738: v.RFC1738,
    RFC3986: v.RFC3986
  }, Cr;
}
var Fr, Wt;
function tn() {
  if (Wt) return Fr;
  Wt = 1;
  var i = /* @__PURE__ */ Br(), l = rn(), v = Object.prototype.hasOwnProperty, h = Array.isArray, m = l(), R = function(e, f) {
    return m.set(e, f), e;
  }, _ = function(e) {
    return m.has(e);
  }, g = function(e) {
    return m.get(e);
  }, E = function(e, f) {
    m.set(e, f);
  }, w = function() {
    for (var y = [], e = 0; e < 256; ++e)
      y.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
    return y;
  }(), b = function(e) {
    for (; e.length > 1; ) {
      var f = e.pop(), S = f.obj[f.prop];
      if (h(S)) {
        for (var q = [], C = 0; C < S.length; ++C)
          typeof S[C] < "u" && q.push(S[C]);
        f.obj[f.prop] = q;
      }
    }
  }, O = function(e, f) {
    for (var S = f && f.plainObjects ? { __proto__: null } : {}, q = 0; q < e.length; ++q)
      typeof e[q] < "u" && (S[q] = e[q]);
    return S;
  }, c = function y(e, f, S) {
    if (!f)
      return e;
    if (typeof f != "object" && typeof f != "function") {
      if (h(e))
        e.push(f);
      else if (e && typeof e == "object")
        if (_(e)) {
          var q = g(e) + 1;
          e[q] = f, E(e, q);
        } else (S && (S.plainObjects || S.allowPrototypes) || !v.call(Object.prototype, f)) && (e[f] = !0);
      else
        return [e, f];
      return e;
    }
    if (!e || typeof e != "object") {
      if (_(f)) {
        for (var C = Object.keys(f), p = S && S.plainObjects ? { __proto__: null, 0: e } : { 0: e }, j = 0; j < C.length; j++) {
          var N = parseInt(C[j], 10);
          p[N + 1] = f[C[j]];
        }
        return R(p, g(f) + 1);
      }
      return [e].concat(f);
    }
    var V = e;
    return h(e) && !h(f) && (V = O(e, S)), h(e) && h(f) ? (f.forEach(function($, B) {
      if (v.call(e, B)) {
        var s = e[B];
        s && typeof s == "object" && $ && typeof $ == "object" ? e[B] = y(s, $, S) : e.push($);
      } else
        e[B] = $;
    }), e) : Object.keys(f).reduce(function($, B) {
      var s = f[B];
      return v.call($, B) ? $[B] = y($[B], s, S) : $[B] = s, $;
    }, V);
  }, d = function(e, f) {
    return Object.keys(f).reduce(function(S, q) {
      return S[q] = f[q], S;
    }, e);
  }, a = function(y, e, f) {
    var S = y.replace(/\+/g, " ");
    if (f === "iso-8859-1")
      return S.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(S);
    } catch {
      return S;
    }
  }, u = 1024, o = function(e, f, S, q, C) {
    if (e.length === 0)
      return e;
    var p = e;
    if (typeof e == "symbol" ? p = Symbol.prototype.toString.call(e) : typeof e != "string" && (p = String(e)), S === "iso-8859-1")
      return escape(p).replace(/%u[0-9a-f]{4}/gi, function(X) {
        return "%26%23" + parseInt(X.slice(2), 16) + "%3B";
      });
    for (var j = "", N = 0; N < p.length; N += u) {
      for (var V = p.length >= u ? p.slice(N, N + u) : p, $ = [], B = 0; B < V.length; ++B) {
        var s = V.charCodeAt(B);
        if (s === 45 || s === 46 || s === 95 || s === 126 || s >= 48 && s <= 57 || s >= 65 && s <= 90 || s >= 97 && s <= 122 || C === i.RFC1738 && (s === 40 || s === 41)) {
          $[$.length] = V.charAt(B);
          continue;
        }
        if (s < 128) {
          $[$.length] = w[s];
          continue;
        }
        if (s < 2048) {
          $[$.length] = w[192 | s >> 6] + w[128 | s & 63];
          continue;
        }
        if (s < 55296 || s >= 57344) {
          $[$.length] = w[224 | s >> 12] + w[128 | s >> 6 & 63] + w[128 | s & 63];
          continue;
        }
        B += 1, s = 65536 + ((s & 1023) << 10 | V.charCodeAt(B) & 1023), $[$.length] = w[240 | s >> 18] + w[128 | s >> 12 & 63] + w[128 | s >> 6 & 63] + w[128 | s & 63];
      }
      j += $.join("");
    }
    return j;
  }, T = function(e) {
    for (var f = [{ obj: { o: e }, prop: "o" }], S = [], q = 0; q < f.length; ++q)
      for (var C = f[q], p = C.obj[C.prop], j = Object.keys(p), N = 0; N < j.length; ++N) {
        var V = j[N], $ = p[V];
        typeof $ == "object" && $ !== null && S.indexOf($) === -1 && (f.push({ obj: p, prop: V }), S.push($));
      }
    return b(f), e;
  }, x = function(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
  }, F = function(e) {
    return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
  }, z = function(e, f, S, q) {
    if (_(e)) {
      var C = g(e) + 1;
      return e[C] = f, E(e, C), e;
    }
    var p = [].concat(e, f);
    return p.length > S ? R(O(p, { plainObjects: q }), p.length - 1) : p;
  }, r = function(e, f) {
    if (h(e)) {
      for (var S = [], q = 0; q < e.length; q += 1)
        S.push(f(e[q]));
      return S;
    }
    return f(e);
  };
  return Fr = {
    arrayToObject: O,
    assign: d,
    combine: z,
    compact: T,
    decode: a,
    encode: o,
    isBuffer: F,
    isOverflow: _,
    isRegExp: x,
    maybeMap: r,
    merge: c
  }, Fr;
}
var _r, kt;
function Yn() {
  if (kt) return _r;
  kt = 1;
  var i = rn(), l = /* @__PURE__ */ tn(), v = /* @__PURE__ */ Br(), h = Object.prototype.hasOwnProperty, m = {
    brackets: function(o) {
      return o + "[]";
    },
    comma: "comma",
    indices: function(o, T) {
      return o + "[" + T + "]";
    },
    repeat: function(o) {
      return o;
    }
  }, R = Array.isArray, _ = Array.prototype.push, g = function(u, o) {
    _.apply(u, R(o) ? o : [o]);
  }, E = Date.prototype.toISOString, w = v.default, b = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: l.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: w,
    formatter: v.formatters[w],
    // deprecated
    indices: !1,
    serializeDate: function(o) {
      return E.call(o);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, O = function(o) {
    return typeof o == "string" || typeof o == "number" || typeof o == "boolean" || typeof o == "symbol" || typeof o == "bigint";
  }, c = {}, d = function u(o, T, x, F, z, r, y, e, f, S, q, C, p, j, N, V, $, B) {
    for (var s = o, X = B, P = 0, I = !1; (X = X.get(c)) !== void 0 && !I; ) {
      var L = X.get(o);
      if (P += 1, typeof L < "u") {
        if (L === P)
          throw new RangeError("Cyclic object value");
        I = !0;
      }
      typeof X.get(c) > "u" && (P = 0);
    }
    if (typeof S == "function" ? s = S(T, s) : s instanceof Date ? s = p(s) : x === "comma" && R(s) && (s = l.maybeMap(s, function(ne) {
      return ne instanceof Date ? p(ne) : ne;
    })), s === null) {
      if (r)
        return f && !V ? f(T, b.encoder, $, "key", j) : T;
      s = "";
    }
    if (O(s) || l.isBuffer(s)) {
      if (f) {
        var A = V ? T : f(T, b.encoder, $, "key", j);
        return [N(A) + "=" + N(f(s, b.encoder, $, "value", j))];
      }
      return [N(T) + "=" + N(String(s))];
    }
    var D = [];
    if (typeof s > "u")
      return D;
    var K;
    if (x === "comma" && R(s))
      V && f && (s = l.maybeMap(s, f)), K = [{ value: s.length > 0 ? s.join(",") || null : void 0 }];
    else if (R(S))
      K = S;
    else {
      var k = Object.keys(s);
      K = q ? k.sort(q) : k;
    }
    var Q = e ? String(T).replace(/\./g, "%2E") : String(T), te = F && R(s) && s.length === 1 ? Q + "[]" : Q;
    if (z && R(s) && s.length === 0)
      return te + "[]";
    for (var H = 0; H < K.length; ++H) {
      var M = K[H], U = typeof M == "object" && M && typeof M.value < "u" ? M.value : s[M];
      if (!(y && U === null)) {
        var W = C && e ? String(M).replace(/\./g, "%2E") : String(M), J = R(s) ? typeof x == "function" ? x(te, W) : te : te + (C ? "." + W : "[" + W + "]");
        B.set(o, P);
        var Z = i();
        Z.set(c, B), g(D, u(
          U,
          J,
          x,
          F,
          z,
          r,
          y,
          e,
          x === "comma" && V && R(s) ? null : f,
          S,
          q,
          C,
          p,
          j,
          N,
          V,
          $,
          Z
        ));
      }
    }
    return D;
  }, a = function(o) {
    if (!o)
      return b;
    if (typeof o.allowEmptyArrays < "u" && typeof o.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof o.encodeDotInKeys < "u" && typeof o.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (o.encoder !== null && typeof o.encoder < "u" && typeof o.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var T = o.charset || b.charset;
    if (typeof o.charset < "u" && o.charset !== "utf-8" && o.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var x = v.default;
    if (typeof o.format < "u") {
      if (!h.call(v.formatters, o.format))
        throw new TypeError("Unknown format option provided.");
      x = o.format;
    }
    var F = v.formatters[x], z = b.filter;
    (typeof o.filter == "function" || R(o.filter)) && (z = o.filter);
    var r;
    if (o.arrayFormat in m ? r = o.arrayFormat : "indices" in o ? r = o.indices ? "indices" : "repeat" : r = b.arrayFormat, "commaRoundTrip" in o && typeof o.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var y = typeof o.allowDots > "u" ? o.encodeDotInKeys === !0 ? !0 : b.allowDots : !!o.allowDots;
    return {
      addQueryPrefix: typeof o.addQueryPrefix == "boolean" ? o.addQueryPrefix : b.addQueryPrefix,
      allowDots: y,
      allowEmptyArrays: typeof o.allowEmptyArrays == "boolean" ? !!o.allowEmptyArrays : b.allowEmptyArrays,
      arrayFormat: r,
      charset: T,
      charsetSentinel: typeof o.charsetSentinel == "boolean" ? o.charsetSentinel : b.charsetSentinel,
      commaRoundTrip: !!o.commaRoundTrip,
      delimiter: typeof o.delimiter > "u" ? b.delimiter : o.delimiter,
      encode: typeof o.encode == "boolean" ? o.encode : b.encode,
      encodeDotInKeys: typeof o.encodeDotInKeys == "boolean" ? o.encodeDotInKeys : b.encodeDotInKeys,
      encoder: typeof o.encoder == "function" ? o.encoder : b.encoder,
      encodeValuesOnly: typeof o.encodeValuesOnly == "boolean" ? o.encodeValuesOnly : b.encodeValuesOnly,
      filter: z,
      format: x,
      formatter: F,
      serializeDate: typeof o.serializeDate == "function" ? o.serializeDate : b.serializeDate,
      skipNulls: typeof o.skipNulls == "boolean" ? o.skipNulls : b.skipNulls,
      sort: typeof o.sort == "function" ? o.sort : null,
      strictNullHandling: typeof o.strictNullHandling == "boolean" ? o.strictNullHandling : b.strictNullHandling
    };
  };
  return _r = function(u, o) {
    var T = u, x = a(o), F, z;
    typeof x.filter == "function" ? (z = x.filter, T = z("", T)) : R(x.filter) && (z = x.filter, F = z);
    var r = [];
    if (typeof T != "object" || T === null)
      return "";
    var y = m[x.arrayFormat], e = y === "comma" && x.commaRoundTrip;
    F || (F = Object.keys(T)), x.sort && F.sort(x.sort);
    for (var f = i(), S = 0; S < F.length; ++S) {
      var q = F[S], C = T[q];
      x.skipNulls && C === null || g(r, d(
        C,
        q,
        y,
        e,
        x.allowEmptyArrays,
        x.strictNullHandling,
        x.skipNulls,
        x.encodeDotInKeys,
        x.encode ? x.encoder : null,
        x.filter,
        x.sort,
        x.allowDots,
        x.serializeDate,
        x.format,
        x.formatter,
        x.encodeValuesOnly,
        x.charset,
        f
      ));
    }
    var p = r.join(x.delimiter), j = x.addQueryPrefix === !0 ? "?" : "";
    return x.charsetSentinel && (x.charset === "iso-8859-1" ? j += "utf8=%26%2310003%3B&" : j += "utf8=%E2%9C%93&"), p.length > 0 ? j + p : "";
  }, _r;
}
var Tr, Gt;
function Xn() {
  if (Gt) return Tr;
  Gt = 1;
  var i = /* @__PURE__ */ tn(), l = Object.prototype.hasOwnProperty, v = Array.isArray, h = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: i.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, m = function(d) {
    return d.replace(/&#(\d+);/g, function(a, u) {
      return String.fromCharCode(parseInt(u, 10));
    });
  }, R = function(d, a, u) {
    if (d && typeof d == "string" && a.comma && d.indexOf(",") > -1)
      return d.split(",");
    if (a.throwOnLimitExceeded && u >= a.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + a.arrayLimit + " element" + (a.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return d;
  }, _ = "utf8=%26%2310003%3B", g = "utf8=%E2%9C%93", E = function(a, u) {
    var o = { __proto__: null }, T = u.ignoreQueryPrefix ? a.replace(/^\?/, "") : a;
    T = T.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var x = u.parameterLimit === 1 / 0 ? void 0 : u.parameterLimit, F = T.split(
      u.delimiter,
      u.throwOnLimitExceeded ? x + 1 : x
    );
    if (u.throwOnLimitExceeded && F.length > x)
      throw new RangeError("Parameter limit exceeded. Only " + x + " parameter" + (x === 1 ? "" : "s") + " allowed.");
    var z = -1, r, y = u.charset;
    if (u.charsetSentinel)
      for (r = 0; r < F.length; ++r)
        F[r].indexOf("utf8=") === 0 && (F[r] === g ? y = "utf-8" : F[r] === _ && (y = "iso-8859-1"), z = r, r = F.length);
    for (r = 0; r < F.length; ++r)
      if (r !== z) {
        var e = F[r], f = e.indexOf("]="), S = f === -1 ? e.indexOf("=") : f + 1, q, C;
        if (S === -1 ? (q = u.decoder(e, h.decoder, y, "key"), C = u.strictNullHandling ? null : "") : (q = u.decoder(e.slice(0, S), h.decoder, y, "key"), q !== null && (C = i.maybeMap(
          R(
            e.slice(S + 1),
            u,
            v(o[q]) ? o[q].length : 0
          ),
          function(j) {
            return u.decoder(j, h.decoder, y, "value");
          }
        ))), C && u.interpretNumericEntities && y === "iso-8859-1" && (C = m(String(C))), e.indexOf("[]=") > -1 && (C = v(C) ? [C] : C), q !== null) {
          var p = l.call(o, q);
          p && u.duplicates === "combine" ? o[q] = i.combine(
            o[q],
            C,
            u.arrayLimit,
            u.plainObjects
          ) : (!p || u.duplicates === "last") && (o[q] = C);
        }
      }
    return o;
  }, w = function(d, a, u, o) {
    var T = 0;
    if (d.length > 0 && d[d.length - 1] === "[]") {
      var x = d.slice(0, -1).join("");
      T = Array.isArray(a) && a[x] ? a[x].length : 0;
    }
    for (var F = o ? a : R(a, u, T), z = d.length - 1; z >= 0; --z) {
      var r, y = d[z];
      if (y === "[]" && u.parseArrays)
        i.isOverflow(F) ? r = F : r = u.allowEmptyArrays && (F === "" || u.strictNullHandling && F === null) ? [] : i.combine(
          [],
          F,
          u.arrayLimit,
          u.plainObjects
        );
      else {
        r = u.plainObjects ? { __proto__: null } : {};
        var e = y.charAt(0) === "[" && y.charAt(y.length - 1) === "]" ? y.slice(1, -1) : y, f = u.decodeDotInKeys ? e.replace(/%2E/g, ".") : e, S = parseInt(f, 10);
        !u.parseArrays && f === "" ? r = { 0: F } : !isNaN(S) && y !== f && String(S) === f && S >= 0 && u.parseArrays && S <= u.arrayLimit ? (r = [], r[S] = F) : f !== "__proto__" && (r[f] = F);
      }
      F = r;
    }
    return F;
  }, b = function(a, u) {
    var o = u.allowDots ? a.replace(/\.([^.[]+)/g, "[$1]") : a;
    if (u.depth <= 0)
      return !u.plainObjects && l.call(Object.prototype, o) && !u.allowPrototypes ? void 0 : [o];
    var T = /(\[[^[\]]*])/, x = /(\[[^[\]]*])/g, F = T.exec(o), z = F ? o.slice(0, F.index) : o, r = [];
    if (z) {
      if (!u.plainObjects && l.call(Object.prototype, z) && !u.allowPrototypes)
        return;
      r.push(z);
    }
    for (var y = 0; (F = x.exec(o)) !== null && y < u.depth; ) {
      y += 1;
      var e = F[1].slice(1, -1);
      if (!u.plainObjects && l.call(Object.prototype, e) && !u.allowPrototypes)
        return;
      r.push(F[1]);
    }
    if (F) {
      if (u.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + u.depth + " and strictDepth is true");
      r.push("[" + o.slice(F.index) + "]");
    }
    return r;
  }, O = function(a, u, o, T) {
    if (a) {
      var x = b(a, o);
      if (x)
        return w(x, u, o, T);
    }
  }, c = function(a) {
    if (!a)
      return h;
    if (typeof a.allowEmptyArrays < "u" && typeof a.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof a.decodeDotInKeys < "u" && typeof a.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (a.decoder !== null && typeof a.decoder < "u" && typeof a.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof a.charset < "u" && a.charset !== "utf-8" && a.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof a.throwOnLimitExceeded < "u" && typeof a.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var u = typeof a.charset > "u" ? h.charset : a.charset, o = typeof a.duplicates > "u" ? h.duplicates : a.duplicates;
    if (o !== "combine" && o !== "first" && o !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var T = typeof a.allowDots > "u" ? a.decodeDotInKeys === !0 ? !0 : h.allowDots : !!a.allowDots;
    return {
      allowDots: T,
      allowEmptyArrays: typeof a.allowEmptyArrays == "boolean" ? !!a.allowEmptyArrays : h.allowEmptyArrays,
      allowPrototypes: typeof a.allowPrototypes == "boolean" ? a.allowPrototypes : h.allowPrototypes,
      allowSparse: typeof a.allowSparse == "boolean" ? a.allowSparse : h.allowSparse,
      arrayLimit: typeof a.arrayLimit == "number" ? a.arrayLimit : h.arrayLimit,
      charset: u,
      charsetSentinel: typeof a.charsetSentinel == "boolean" ? a.charsetSentinel : h.charsetSentinel,
      comma: typeof a.comma == "boolean" ? a.comma : h.comma,
      decodeDotInKeys: typeof a.decodeDotInKeys == "boolean" ? a.decodeDotInKeys : h.decodeDotInKeys,
      decoder: typeof a.decoder == "function" ? a.decoder : h.decoder,
      delimiter: typeof a.delimiter == "string" || i.isRegExp(a.delimiter) ? a.delimiter : h.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof a.depth == "number" || a.depth === !1 ? +a.depth : h.depth,
      duplicates: o,
      ignoreQueryPrefix: a.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof a.interpretNumericEntities == "boolean" ? a.interpretNumericEntities : h.interpretNumericEntities,
      parameterLimit: typeof a.parameterLimit == "number" ? a.parameterLimit : h.parameterLimit,
      parseArrays: a.parseArrays !== !1,
      plainObjects: typeof a.plainObjects == "boolean" ? a.plainObjects : h.plainObjects,
      strictDepth: typeof a.strictDepth == "boolean" ? !!a.strictDepth : h.strictDepth,
      strictNullHandling: typeof a.strictNullHandling == "boolean" ? a.strictNullHandling : h.strictNullHandling,
      throwOnLimitExceeded: typeof a.throwOnLimitExceeded == "boolean" ? a.throwOnLimitExceeded : !1
    };
  };
  return Tr = function(d, a) {
    var u = c(a);
    if (d === "" || d === null || typeof d > "u")
      return u.plainObjects ? { __proto__: null } : {};
    for (var o = typeof d == "string" ? E(d, u) : d, T = u.plainObjects ? { __proto__: null } : {}, x = Object.keys(o), F = 0; F < x.length; ++F) {
      var z = x[F], r = O(z, o[z], u, typeof d == "string");
      T = i.merge(T, r, u);
    }
    return u.allowSparse === !0 ? T : i.compact(T);
  }, Tr;
}
var Mr, zt;
function ea() {
  if (zt) return Mr;
  zt = 1;
  var i = /* @__PURE__ */ Yn(), l = /* @__PURE__ */ Xn(), v = /* @__PURE__ */ Br();
  return Mr = {
    formats: v,
    parse: l,
    stringify: i
  }, Mr;
}
var jt;
function ra() {
  if (jt) return de;
  jt = 1;
  var i = On();
  function l() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var v = /^([a-z0-9.+-]+:)/i, h = /:[0-9]*$/, m = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, R = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], _ = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(R), g = ["'"].concat(_), E = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(g), w = [
    "/",
    "?",
    "#"
  ], b = 255, O = /^[+a-z0-9A-Z_-]{0,63}$/, c = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, d = {
    javascript: !0,
    "javascript:": !0
  }, a = {
    javascript: !0,
    "javascript:": !0
  }, u = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, o = /* @__PURE__ */ ea();
  function T(r, y, e) {
    if (r && typeof r == "object" && r instanceof l)
      return r;
    var f = new l();
    return f.parse(r, y, e), f;
  }
  l.prototype.parse = function(r, y, e) {
    if (typeof r != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof r);
    var f = r.indexOf("?"), S = f !== -1 && f < r.indexOf("#") ? "?" : "#", q = r.split(S), C = /\\/g;
    q[0] = q[0].replace(C, "/"), r = q.join(S);
    var p = r;
    if (p = p.trim(), !e && r.split("#").length === 1) {
      var j = m.exec(p);
      if (j)
        return this.path = p, this.href = p, this.pathname = j[1], j[2] ? (this.search = j[2], y ? this.query = o.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : y && (this.search = "", this.query = {}), this;
    }
    var N = v.exec(p);
    if (N) {
      N = N[0];
      var V = N.toLowerCase();
      this.protocol = V, p = p.substr(N.length);
    }
    if (e || N || p.match(/^\/\/[^@/]+@[^@/]+/)) {
      var $ = p.substr(0, 2) === "//";
      $ && !(N && a[N]) && (p = p.substr(2), this.slashes = !0);
    }
    if (!a[N] && ($ || N && !u[N])) {
      for (var B = -1, s = 0; s < w.length; s++) {
        var X = p.indexOf(w[s]);
        X !== -1 && (B === -1 || X < B) && (B = X);
      }
      var P, I;
      B === -1 ? I = p.lastIndexOf("@") : I = p.lastIndexOf("@", B), I !== -1 && (P = p.slice(0, I), p = p.slice(I + 1), this.auth = decodeURIComponent(P)), B = -1;
      for (var s = 0; s < E.length; s++) {
        var X = p.indexOf(E[s]);
        X !== -1 && (B === -1 || X < B) && (B = X);
      }
      B === -1 && (B = p.length), this.host = p.slice(0, B), p = p.slice(B), this.parseHost(), this.hostname = this.hostname || "";
      var L = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!L)
        for (var A = this.hostname.split(/\./), s = 0, D = A.length; s < D; s++) {
          var K = A[s];
          if (K && !K.match(O)) {
            for (var k = "", Q = 0, te = K.length; Q < te; Q++)
              K.charCodeAt(Q) > 127 ? k += "x" : k += K[Q];
            if (!k.match(O)) {
              var H = A.slice(0, s), M = A.slice(s + 1), U = K.match(c);
              U && (H.push(U[1]), M.unshift(U[2])), M.length && (p = "/" + M.join(".") + p), this.hostname = H.join(".");
              break;
            }
          }
        }
      this.hostname.length > b ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), L || (this.hostname = i.toASCII(this.hostname));
      var W = this.port ? ":" + this.port : "", J = this.hostname || "";
      this.host = J + W, this.href += this.host, L && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), p[0] !== "/" && (p = "/" + p));
    }
    if (!d[V])
      for (var s = 0, D = g.length; s < D; s++) {
        var Z = g[s];
        if (p.indexOf(Z) !== -1) {
          var ne = encodeURIComponent(Z);
          ne === Z && (ne = escape(Z)), p = p.split(Z).join(ne);
        }
      }
    var ae = p.indexOf("#");
    ae !== -1 && (this.hash = p.substr(ae), p = p.slice(0, ae));
    var oe = p.indexOf("?");
    if (oe !== -1 ? (this.search = p.substr(oe), this.query = p.substr(oe + 1), y && (this.query = o.parse(this.query)), p = p.slice(0, oe)) : y && (this.search = "", this.query = {}), p && (this.pathname = p), u[V] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var W = this.pathname || "", ie = this.search || "";
      this.path = W + ie;
    }
    return this.href = this.format(), this;
  };
  function x(r) {
    return typeof r == "string" && (r = T(r)), r instanceof l ? r.format() : l.prototype.format.call(r);
  }
  l.prototype.format = function() {
    var r = this.auth || "";
    r && (r = encodeURIComponent(r), r = r.replace(/%3A/i, ":"), r += "@");
    var y = this.protocol || "", e = this.pathname || "", f = this.hash || "", S = !1, q = "";
    this.host ? S = r + this.host : this.hostname && (S = r + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (S += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (q = o.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var C = this.search || q && "?" + q || "";
    return y && y.substr(-1) !== ":" && (y += ":"), this.slashes || (!y || u[y]) && S !== !1 ? (S = "//" + (S || ""), e && e.charAt(0) !== "/" && (e = "/" + e)) : S || (S = ""), f && f.charAt(0) !== "#" && (f = "#" + f), C && C.charAt(0) !== "?" && (C = "?" + C), e = e.replace(/[?#]/g, function(p) {
      return encodeURIComponent(p);
    }), C = C.replace("#", "%23"), y + S + e + C + f;
  };
  function F(r, y) {
    return T(r, !1, !0).resolve(y);
  }
  l.prototype.resolve = function(r) {
    return this.resolveObject(T(r, !1, !0)).format();
  };
  function z(r, y) {
    return r ? T(r, !1, !0).resolveObject(y) : y;
  }
  return l.prototype.resolveObject = function(r) {
    if (typeof r == "string") {
      var y = new l();
      y.parse(r, !1, !0), r = y;
    }
    for (var e = new l(), f = Object.keys(this), S = 0; S < f.length; S++) {
      var q = f[S];
      e[q] = this[q];
    }
    if (e.hash = r.hash, r.href === "")
      return e.href = e.format(), e;
    if (r.slashes && !r.protocol) {
      for (var C = Object.keys(r), p = 0; p < C.length; p++) {
        var j = C[p];
        j !== "protocol" && (e[j] = r[j]);
      }
      return u[e.protocol] && e.hostname && !e.pathname && (e.pathname = "/", e.path = e.pathname), e.href = e.format(), e;
    }
    if (r.protocol && r.protocol !== e.protocol) {
      if (!u[r.protocol]) {
        for (var N = Object.keys(r), V = 0; V < N.length; V++) {
          var $ = N[V];
          e[$] = r[$];
        }
        return e.href = e.format(), e;
      }
      if (e.protocol = r.protocol, !r.host && !a[r.protocol]) {
        for (var D = (r.pathname || "").split("/"); D.length && !(r.host = D.shift()); )
          ;
        r.host || (r.host = ""), r.hostname || (r.hostname = ""), D[0] !== "" && D.unshift(""), D.length < 2 && D.unshift(""), e.pathname = D.join("/");
      } else
        e.pathname = r.pathname;
      if (e.search = r.search, e.query = r.query, e.host = r.host || "", e.auth = r.auth, e.hostname = r.hostname || r.host, e.port = r.port, e.pathname || e.search) {
        var B = e.pathname || "", s = e.search || "";
        e.path = B + s;
      }
      return e.slashes = e.slashes || r.slashes, e.href = e.format(), e;
    }
    var X = e.pathname && e.pathname.charAt(0) === "/", P = r.host || r.pathname && r.pathname.charAt(0) === "/", I = P || X || e.host && r.pathname, L = I, A = e.pathname && e.pathname.split("/") || [], D = r.pathname && r.pathname.split("/") || [], K = e.protocol && !u[e.protocol];
    if (K && (e.hostname = "", e.port = null, e.host && (A[0] === "" ? A[0] = e.host : A.unshift(e.host)), e.host = "", r.protocol && (r.hostname = null, r.port = null, r.host && (D[0] === "" ? D[0] = r.host : D.unshift(r.host)), r.host = null), I = I && (D[0] === "" || A[0] === "")), P)
      e.host = r.host || r.host === "" ? r.host : e.host, e.hostname = r.hostname || r.hostname === "" ? r.hostname : e.hostname, e.search = r.search, e.query = r.query, A = D;
    else if (D.length)
      A || (A = []), A.pop(), A = A.concat(D), e.search = r.search, e.query = r.query;
    else if (r.search != null) {
      if (K) {
        e.host = A.shift(), e.hostname = e.host;
        var k = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
        k && (e.auth = k.shift(), e.hostname = k.shift(), e.host = e.hostname);
      }
      return e.search = r.search, e.query = r.query, (e.pathname !== null || e.search !== null) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.href = e.format(), e;
    }
    if (!A.length)
      return e.pathname = null, e.search ? e.path = "/" + e.search : e.path = null, e.href = e.format(), e;
    for (var Q = A.slice(-1)[0], te = (e.host || r.host || A.length > 1) && (Q === "." || Q === "..") || Q === "", H = 0, M = A.length; M >= 0; M--)
      Q = A[M], Q === "." ? A.splice(M, 1) : Q === ".." ? (A.splice(M, 1), H++) : H && (A.splice(M, 1), H--);
    if (!I && !L)
      for (; H--; H)
        A.unshift("..");
    I && A[0] !== "" && (!A[0] || A[0].charAt(0) !== "/") && A.unshift(""), te && A.join("/").substr(-1) !== "/" && A.push("");
    var U = A[0] === "" || A[0] && A[0].charAt(0) === "/";
    if (K) {
      e.hostname = U ? "" : A.length ? A.shift() : "", e.host = e.hostname;
      var k = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
      k && (e.auth = k.shift(), e.hostname = k.shift(), e.host = e.hostname);
    }
    return I = I || e.host && A.length, I && !U && A.unshift(""), A.length > 0 ? e.pathname = A.join("/") : (e.pathname = null, e.path = null), (e.pathname !== null || e.search !== null) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.auth = r.auth || e.auth, e.slashes = e.slashes || r.slashes, e.href = e.format(), e;
  }, l.prototype.parseHost = function() {
    var r = this.host, y = h.exec(r);
    y && (y = y[0], y !== ":" && (this.port = y.substr(1)), r = r.substr(0, r.length - y.length)), r && (this.hostname = r);
  }, de.parse = T, de.resolve = F, de.resolveObject = z, de.format = x, de.Url = l, de;
}
var ta = ra();
const na = "_horizontalTabsWrapper_lulv0_1", aa = "_horizontalTabsWrapperSc_lulv0_12", oa = "_horizontalTabsCard_lulv0_17", Dr = {
  horizontalTabsWrapper: na,
  horizontalTabsWrapperSc: aa,
  horizontalTabsCard: oa
}, ia = () => {
  var R, _;
  const l = Ht().query.tab === "Facility Manager", v = mn({
    filters: { mutationKey: ["bulk-facility-rename"] },
    select: (g) => {
      var E;
      return (E = g == null ? void 0 : g.state) == null ? void 0 : E.data;
    }
  }), h = v == null ? void 0 : v[(v == null ? void 0 : v.length) - 1], m = ((R = h == null ? void 0 : h.data) == null ? void 0 : R.statusCode) !== 200 ? (_ = h == null ? void 0 : h.data) == null ? void 0 : _.message : null;
  return m && l ? /* @__PURE__ */ se("div", { className: "w-100 mb-3", children: /* @__PURE__ */ se(gn, { kind: "error", className: "w-100", children: m }) }) : null;
}, fa = ({
  fields: i,
  params: l,
  rendering: v
}) => {
  const h = Ht(), m = ke(
    () => {
      var c;
      return (c = i == null ? void 0 : i.items) == null ? void 0 : c.map((d) => d == null ? void 0 : d.fields);
    },
    [i == null ? void 0 : i.items]
  ), R = ke(() => {
    const c = h.query.tab, d = m == null ? void 0 : m.some((a) => {
      var u;
      return ((u = a == null ? void 0 : a.text) == null ? void 0 : u.value) === c;
    });
    return Sn(c) && d ? c : void 0;
  }, [h.query.tab, m]), _ = ke(
    () => m == null ? void 0 : m.find((c) => {
      var d;
      return ((d = c == null ? void 0 : c.text) == null ? void 0 : d.value) === R;
    }),
    [m, R]
  ), g = vn.isEditorActive(), E = pn(
    (c) => {
      const { query: d, pathname: a } = ta.parse(h.asPath, !0);
      h.push({ pathname: a, query: { ...d, tab: c } }, void 0, {
        shallow: !0
      });
    },
    [h]
  );
  yn(() => {
    var c, d;
    !m || !m.length || !_ && ((d = (c = m == null ? void 0 : m[0]) == null ? void 0 : c.text) != null && d.value) && E(m[0].text.value);
  }, [_, E, m]);
  const w = (c, d) => {
    (c.key === "Enter" || c.key === " ") && (c.preventDefault(), E(d));
  }, b = !!m.length, O = m.length <= 3;
  return /* @__PURE__ */ We(cn, { children: [
    /* @__PURE__ */ se(ia, {}),
    /* @__PURE__ */ We("div", { "data-test-id": v.componentName, children: [
      b && /* @__PURE__ */ se(
        Qr,
        {
          label: R || "",
          labelBackground: "plain",
          rounded: !0,
          full: !0,
          kind: "shadow",
          className: Ge("w-100 w-sm-50 w-lg-25 mb-2 position-relative z-2", {
            "d-none": O,
            "d-flex d-lg-none": !O
          }),
          children: m == null ? void 0 : m.map(({ text: c }) => /* @__PURE__ */ se(
            Qr.Item,
            {
              value: c.value,
              active: (c == null ? void 0 : c.value) === R,
              onClick: () => {
                E(c.value);
              },
              onKeyDown: (d) => w(d, c.value),
              children: c.value
            },
            c.value
          ))
        }
      ),
      /* @__PURE__ */ se(Jr, { className: Dr.horizontalTabsCard, children: /* @__PURE__ */ We(Jr.Content, { className: Ge((l == null ? void 0 : l.shouldFit) && Dr.horizontalTabsWrapperSc), children: [
        b && /* @__PURE__ */ se(
          Zr,
          {
            color: "blue",
            kind: "plain",
            onNeuChange: (c) => {
              E(c.value);
            },
            size: "default",
            value: R,
            className: Ge(!(l != null && l.shouldFit) && Dr.horizontalTabsWrapper, {
              "d-flex": O,
              "d-none d-lg-flex": !O
            }),
            children: m.map((c) => {
              var d, a;
              return /* @__PURE__ */ se(Zr.Item, { value: (d = c == null ? void 0 : c.text) == null ? void 0 : d.value, children: (a = c == null ? void 0 : c.text) == null ? void 0 : a.value }, (c == null ? void 0 : c.id) ?? wn("tab-id-"));
            })
          },
          R
        ),
        g ? m == null ? void 0 : m.map((c, d) => {
          var u;
          const a = (c == null ? void 0 : c.id) ?? ((u = c == null ? void 0 : c.text) == null ? void 0 : u.value) ?? d;
          return /* @__PURE__ */ se(
            Yr,
            {
              name: `tabContent-${d}`,
              rendering: v
            },
            `tabContent-${a}`
          );
        }) : /* @__PURE__ */ se(
          Yr,
          {
            name: `tabContent-${m == null ? void 0 : m.findIndex((c) => {
              var d;
              return ((d = c == null ? void 0 : c.text) == null ? void 0 : d.value) === R;
            })}`,
            rendering: v
          }
        )
      ] }) })
    ] })
  ] });
}, wa = dn()(fa);
export {
  wa as SharedHorizontalTabs
};
